// The lead's local time beside every send control (DAY-AGENTS-2026-10-03 §7): "3:12 pm Mountain" from leads.state,
// or "state unknown"; and, outside the window a candidate-facing text may go, when the quiet hours lift. The window
// itself is quietHours.js's -- one copy, pinned against the agent's by quietHours.test.js -- nothing here redefines it.
import { resolveTimezone, withinDraftSendWindow, nextDraftSendTime, sendTimeLabel } from './quietHours';

export const STATE_UNKNOWN_LABEL = 'state unknown';

const ZONE_NAMES = {
  'America/New_York': 'Eastern', 'America/Indiana/Indianapolis': 'Eastern', 'America/Chicago': 'Central',
  'America/Denver': 'Mountain', 'America/Boise': 'Mountain', 'America/Phoenix': 'Mountain (Arizona)',
  'America/Los_Angeles': 'Pacific', 'America/Anchorage': 'Alaska', 'Pacific/Honolulu': 'Hawaii',
};

/** "3:12 pm Mountain" for a lead in `state` at `nowMs`, or "state unknown". */
export function localTimeLabel(nowMs, state) {
  const tz = resolveTimezone(state);
  if (!tz) return STATE_UNKNOWN_LABEL;
  const t = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit', hour12: true })
    .format(new Date(nowMs)).replace(/\s*([AP])M$/i, (m, ap) => ` ${ap.toLowerCase()}m`);
  return `${t} ${ZONE_NAMES[tz] || tz}`;
}

/** null inside the window; else "quiet hours there -- lifts Sat, 8:00 AM CDT" (the strict window when no state). */
export function quietLiftLabel(nowMs, state) {
  if (withinDraftSendWindow(nowMs, state)) return null;
  const at = nextDraftSendTime(nowMs, state);
  return at ? `quiet hours there -- lifts ${sendTimeLabel(at, state)}` : 'quiet hours there';
}

/** The lead a conversation belongs to: the candidate_id link first, else the newest lead on the same phone. */
export function leadForConversation(conv, leads) {
  if (!conv || !Array.isArray(leads)) return null;
  const cand = String(conv.candidate_id || '').toLowerCase();
  const linked = cand && leads.find((l) => String(l.id).toLowerCase() === cand);
  if (linked) return linked;
  const digits = (v) => String(v || '').replace(/\D/g, '').slice(-10);
  const p = digits(conv.candidate_phone);
  if (p.length !== 10) return null;
  const same = leads.filter((l) => digits(l.phone) === p);
  same.sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
  return same[0] || null;
}
